import { useCallback } from "react";
import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { BLOCK } from "tagTypes";

export const useBlockQuery = (zoneId, query = {}) =>
  useGetQuery({
    endpoint: `/zone/${zoneId}/block`,
    query,
    tags: [BLOCK],
  });

export const useLazyBlockQuery = () => {
  const [getBlock, data] = useLazyGetQuery();
  const block = useCallback(
    async (zoneId, query = {}, isFireSafety = false) =>
      await getBlock(
        {
          endpoint: isFireSafety
            ? `/firesafety-address/zone/${zoneId}/block`
            : `/zone/${zoneId}/block`,
          query,
          tags: [BLOCK],
        },
        true
      ).unwrap(),
    [getBlock]
  );
  return [block, data];
};

export const usePostBlockMutation = () => {
  const [block, data] = usePostMutation();
  const addBlock = async (payload, query = {}) =>
    await block({
      endpoint: "/block",
      query,
      payload: payload || {},
      toastMessage: "Block added successfully",
      tags: [BLOCK],
    }).unwrap();
  return [addBlock, data];
};

export const usePutBlockMutation = () => {
  const [block, data] = usePutMutation();
  const updateBlock = async (payload, query = {}) =>
    await block({
      endpoint: "/block",
      query,
      payload: payload || {},
      toastMessage: "Block updated successfully",
      tags: [BLOCK],
    }).unwrap();
  return [updateBlock, data];
};

export const useDeleteBlockMutation = () => {
  const [block, data] = useDeleteMutation();
  const deleteBlock = async (query = {}) =>
    await block({
      endpoint: "/block",
      query,
      toastMessage: "Block deleted successully",
      tags: [BLOCK],
    }).unwrap();
  return [deleteBlock, data];
};
